import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getBusinessProcessBaseExecutors(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTORS,
		options
	)
}

function _getBusinessProcessBaseExecutorPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_POPUP,
		options
	)
}

function _getBusinessProcessBaseExecutorPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_PREVIEW,
		options
	)
}

function _getBusinessProcessBaseExecutor(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR,
		options
	)
}

function _createBusinessProcessBaseExecutor(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].CREATE_BUSINESS_PROCESS_BASE_EXECUTOR,
		options
	)
}

function _patchBusinessProcessBaseExecutor(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PATCH_BUSINESS_PROCESS_BASE_EXECUTOR,
		options
	)
}

function _putBusinessProcessBaseExecutor(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PUT_BUSINESS_PROCESS_BASE_EXECUTOR,
		options
	)
}

function _deleteBusinessProcessBaseExecutor(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].DELETE_BUSINESS_PROCESS_BASE_EXECUTOR,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTORS]: _getBusinessProcessBaseExecutors, 
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_POPUP]:
		_getBusinessProcessBaseExecutorPopup,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_PREVIEW]:
		_getBusinessProcessBaseExecutorPreview,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR]: _getBusinessProcessBaseExecutor,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].CREATE_BUSINESS_PROCESS_BASE_EXECUTOR]: _createBusinessProcessBaseExecutor,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PATCH_BUSINESS_PROCESS_BASE_EXECUTOR]: _patchBusinessProcessBaseExecutor,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PUT_BUSINESS_PROCESS_BASE_EXECUTOR]: _putBusinessProcessBaseExecutor,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].DELETE_BUSINESS_PROCESS_BASE_EXECUTOR]: _deleteBusinessProcessBaseExecutor,
}
